//
// Insight.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../TransportModel";
import "../../depot/InsightItem";
import "./Connection";

var Insight = createModule("transport::Insight", ["commons::PropertyOwner","commons::BaseModel","transport::TransportModel"], EventDispatcher, [
    ,
    {
        item: 1,
        reportId: 7,
        isDeleted: 2,
        isReportPackageGenerated: 2,
        connection: 1,
        id: 7,
        isHidden: 2,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default Insight;
